import NPAReportTypes from './npa-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	fetchNPADetailResponse: null,
	fetchNPADetailArr: [],
};

const npaReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START FETCH NPA DETAILS ******************** */
		case NPAReportTypes.FETCH_NPA_REPORT_SUCCESS:
			return {
				...state,
				fetchNPADetailResponse: action.payload,
				fetchNPADetailArr: docodeHexResponse(action.payload, 'GetNPAReportDetailsKey'),
			};

		case NPAReportTypes.FETCH_NPA_REPORT_FAILURE:
			return { ...state, fetchNPADetailResponse: action.payload };

		case NPAReportTypes.FETCH_NPA_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchNPADetailResponse: null };
		/** *********************  END FETCH NPA DETAILS ******************** */
		default:
			return state;
	}
};

export default npaReportReducer;
